import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { AdultsPickerContentModal } from '../../../../forms/adults-picker/AdultsPickerContentModal'

export type AdultsPickerProps = {
  field: ControllerRenderProps<FieldValues, string>
  onValid: () => void
}
export const AdultsPicker = ({ field, onValid }: AdultsPickerProps) => {
  return (
    <AdultsPickerContentModal
      field={field}
      isMobile
      onValid={onValid}
      revampPicker
    />
  )
}
